




































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Ref } from 'vue-property-decorator';
import { InternalSite } from '../../api';
import SiteDetail from './SiteDetail.vue';
import SiteEditDialog from './SiteEditDialog.vue';

@Component({
  components: { SiteDetail, SiteEditDialog }
})
export default class SiteAdmin extends Vue {
  selectedSiteId: number | null = null;
  @Ref('site-edit-dialog') siteEditDialog!: SiteEditDialog;
  siteSearch: string | null = null;

  get sites(): Array<InternalSite> {
    return this.$store.state.sites.all;
  }

  async mounted() {
    const routeSiteId = parseInt(this.$route.params.id);
    await this.$store.dispatch('sites/refresh');

    if (Number.isInteger(routeSiteId)) {
      this.showSite(routeSiteId);
    }
  }

  @Watch('$route')
  onRouteChange(to: any) {
    this.showSite(parseInt(to.params.id));
  }

  showSite(id: any) {
    if (Number.isInteger(id)) {
      if (this.$store.getters['sites/getSite'](id)) {
        this.selectedSiteId = id;
      } else {
        this.$router.push('/sites');
      }
    } else {
      this.selectedSiteId = null;
    }
  }

  addSite() {
    this.siteEditDialog.show(null, false);
  }

  even(sites: Array<InternalSite>) {
    return sites.filter(site => {
      return !this.siteSearch || site.name.includes(this.siteSearch) || site.title.includes(this.siteSearch);
    });
  }
}
